module.exports = __webpack_public_path__ + "img/goodComment.1d2e845f.png";